import React from "react";

//assets
import card1 from "../../Assets/card1.svg";
import card2 from "../../Assets/card2.svg";
import line from "../../Assets/lines.svg";
import youtube from "../../Assets/youtubelogo.svg";
import inlogo from "../../Assets/in.svg";
import insta from "../../Assets/insta.svg";
import fb from "../../Assets/fb.svg";

function AboutUsSection() {
  return (
    <div className="aboutUsSection">
      <div className="aboutUsSection_top">
        <div className="aboutUsSection_title">The Freedom to Create</div>
        <div className="aboutUsSection_description">Mark-1 is licensed as 3D , owned by Stark Industries and team. For that reason mark-1 is Free and Open Source software, forever.</div>
      </div>
      <div className="aboutUsSection_cards">
        <div className="aboutUsSection_cards1">
          <img src={card1} alt="" />
        </div>
        <div className="aboutUsSection_cards2">
          <img src={card2} alt="" />
        </div>
      </div>
      <div className="aboutUsSection_basecard">
        <div className="aboutUsSection_basecard_img">
          <div className="aboutUsSection_title">Solutions for big teams to achieve big dreams</div>
          <div className="aboutUsSection_description">
            Our enterprise-level solutions provide large teams and organizations in every industry with everything they need to build awesome real-time 3D projects.
          </div>
        </div>
      </div>

      <div className="socialinks">
        <div>
          <img src={youtube} alt="3D Model" />
        </div>
        <div>
          <img src={fb} alt="3D Model" />
        </div>
        <div>
          <img src={insta} alt="3D Model" />
        </div>
        <div>
          <img src={inlogo} alt="3D Model" />
        </div>
      </div>

      <div className="line">
        <img src={line} alt="3D Model" />
      </div>
    </div>
  );
}

export default AboutUsSection;
